import { Directive, Input, TemplateRef, ViewContainerRef, OnDestroy } from '@angular/core';
import { AuthenticationService } from '../../core/services/authentication.service';
import { AppConfig } from '../config/app-config';

@Directive({
	selector: '[appFeatureAccess]'
})
export class FeatureAccessDirective implements OnDestroy {
	featureAccess: string[];
	sub: any;

	constructor(
		private templateRef: TemplateRef<any>,
		private viewContainer: ViewContainerRef,
		private authService: AuthenticationService,
		private appConfig: AppConfig
	) { }

	@Input() set appFeatureAccess(permission: string) {
		if (!permission) {
			this.viewContainer.createEmbeddedView(this.templateRef);
			return;
		}
		this.sub = this.authService.featureAccess.subscribe(val => {
			this.viewContainer.clear();
			this.featureAccess = val;
			//start.This code will be remove once these feature access is added by backend
			if (this.appConfig.SHOW_FEE_WAIVER) {
				this.featureAccess.push('show_fee_waiver');
			}
			if (JSON.parse(localStorage.getItem('agentDashboardData'))?.crmEnabled) {
				this.featureAccess.push('show_help_center');
			}

			if (this.appConfig.SHOW_TRAINING_VIEW) {
				this.featureAccess.push('show_training_view');
			}

			if (this.appConfig.SHOW_STAFF_USERS_MENU) {
				this.featureAccess.push('can_use_staff_user_feature');
			}

			const show =  (this.appConfig.EXTENDED_STATEMENT_DOWNLOAD && permission.toLowerCase() === 'can_download_extended_statement') 
			   || this.featureAccess.includes(permission);
			if (show) {
				this.viewContainer.createEmbeddedView(this.templateRef);
			} else {
				this.viewContainer.clear();
			}
		});
	}

	ngOnDestroy() {
		// this.sub.unsubscribe();
	}

}
